import { render } from "./UpdateDetailSection.vue?vue&type=template&id=472ee09a&scoped=true"
import script from "./UpdateDetailSection.vue?vue&type=script&lang=js"
export * from "./UpdateDetailSection.vue?vue&type=script&lang=js"

import "./UpdateDetailSection.vue?vue&type=style&index=0&id=472ee09a&lang=scss&scoped=true"
import "../style.scss?vue&type=style&index=1&id=472ee09a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472ee09a"]])

export default __exports__